import { read_identity_value } from '../users/user_identity'

/* Read one company department by its saved name. */
export const read_company_department = (departments, departmentName) => {
    const normalizedDepartmentName = read_identity_value(departmentName)

    return departments.find((department) => {
        return read_identity_value(department.name) === normalizedDepartmentName
    }) || null
}

/* Read the single role marked as department head inside one department. */
export const read_department_head_role = (department) => {
    return (department?.roles || []).find((role) => role?.departmentHead) || null
}

/* Read whether one team user is the department head for his saved department. */
export const read_is_department_head_user = (user, departments) => {
    const department = read_company_department(departments, user?.department)
    const departmentHeadRole = read_department_head_role(department)
    const normalizedUserRole = read_identity_value(user?.companyRole)

    if (!department || !departmentHeadRole || !normalizedUserRole) {
        return false
    }

    return normalizedUserRole === read_identity_value(departmentHeadRole.name)
}

/* Read whether one team user belongs to the department marked as company head. */
export const read_is_company_head_user = (user, departments) => {
    const companyHeadDepartment = departments.find((department) => department?.companyHead) || null
    const normalizedUserDepartment = read_identity_value(user?.department)

    if (!companyHeadDepartment || !normalizedUserDepartment) {
        return false
    }

    return normalizedUserDepartment === read_identity_value(companyHeadDepartment.name)
}
